module.exports = __webpack_public_path__ + "static/media/postcard.18d3c45f.jpg";